import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { get, split } from 'lodash';
import { useLocation } from 'react-router-dom';

import {
    NEED_DOMAIN_STEPS,
    NEED_MAIL_SERVER_STEPS,
    INFINCE_ONLY,
} from '../utilities/constants';
import { setStepNumber } from '../store/signup/signupAction';
import { setNavMenu } from '../store/menu/menuAction';

/**
 * Step navigation component
 * @param {*} param0
 */
const StepNavigation = ({
    setStepNumber,
    needDomain,
    needMailServer,
    currentStep,
    setNavMenu,
    menu,
}) => {
    const location = useLocation();
    const pathElems = split(location.pathname, '/');

    useEffect(() => {
        if (needDomain) {
            setNavMenu(NEED_DOMAIN_STEPS);
        } else if (needMailServer) {
            setNavMenu(NEED_MAIL_SERVER_STEPS);
        } else {
            setNavMenu(INFINCE_ONLY);
        }
    }, [needDomain, needMailServer, setNavMenu]);

    /**
     * navigate to a specific step
     * @param {*} element
     */
    const navigateTo = (element) => {
        // someday a use for this feature may come...
        //i made it once...then scrapped it..made it again ...the scrapped it...
    };
    const renderStepOptions = () => {
        return (
            <>
                {menu.map((element, index) => {
                    return (
                        <li
                            key={element.id}
                            className={
                                pathElems[pathElems.length - 1] ===
                                    element.route || currentStep === index + 1
                                    ? 'active'
                                    : index + 1 < currentStep
                                    ? 'finished'
                                    : ''
                            }
                            onClick={() => navigateTo(element)}
                        >
                            <span>0{index + 1}</span>
                            {element.stepTitle}
                        </li>
                    );
                })}
            </>
        );
    };
    return (
        <div className="step-nav ">
            <ul>{renderStepOptions()}</ul>
        </div>
    );
};

const mapStateToProps = (store) => ({
    currentStep: store.signupReducer.currentStep,
    needDomain: get(store, 'signupReducer.needDomain', false),
    needMailServer: get(store, 'signupReducer.needMailServer', false),
    menu: get(store, 'menuReducer.navMenu', []),
});
const mapDispatchToProps = {
    setStepNumber,
    setNavMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepNavigation);
